<template>
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="10" fill="white" />
    <g clip-path="url(#clip0_18417_135362)">
      <path
        d="M35.2683 6.96525C50.097 4.87881 63.8741 17.9277 62.9776 32.8798C62.6866 47.0428 49.3172 58.7696 35.3328 56.7782C50.7272 54.3667 60.6272 39.303 55.8879 24.1829C52.9595 15.1334 44.6974 8.22263 35.2752 7.04513C35.2738 7.01759 35.2711 6.99142 35.2697 6.96388L35.2683 6.96525Z"
        fill="#762ECF"
      />
      <path
        d="M13.4556 35.2527C17.5414 64.2109 58.8232 64.2563 62.9968 35.3464C65.0672 48.5853 54.4313 61.5791 41.2212 62.9576C25.5248 65.051 11.3509 51.0711 13.3513 35.2775C13.3856 35.2692 13.4213 35.2624 13.4556 35.2541V35.2527Z"
        fill="#EA97CF"
      />
      <path
        d="M34.8551 63.1917C-2.75424 65.3829 -0.970839 10.3917 34.9539 13.4435C5.92114 17.5999 5.8827 58.9638 34.8551 63.1917Z"
        fill="#D62FA0"
      />
      <path
        d="M6.9357 34.7308C5.07953 20.6063 16.9593 7.03411 31.1578 7.02447C45.8108 6.21881 58.6612 20.2207 56.687 34.8024C56.6513 34.8024 56.6169 34.8051 56.5812 34.8051C55.1328 22.4628 43.9519 12.6792 31.5738 12.8968C19.3742 12.9175 8.47472 22.5743 7.02631 34.7404C6.9961 34.7376 6.9659 34.7335 6.93707 34.7308H6.9357Z"
        fill="#AD82E2"
      />
      <path
        d="M35.1064 29.3019C35.1064 28.3489 34.6835 27.5005 33.9449 26.7582C33.2049 26.122 32.3606 25.8052 31.4091 25.8052C30.7749 25.8052 30.2477 26.0173 29.7191 26.3354C29.402 26.6535 29.1905 26.8656 28.9791 27.0777C28.3448 27.82 28.0291 28.773 28.0291 29.7261C28.1348 31.7395 29.8248 33.2227 31.7263 33.1167C32.6763 33.1167 33.522 32.6925 34.1563 31.9516C34.8963 31.2093 35.2121 30.2563 35.1064 29.3033V29.3019Z"
        fill="#D62FA0"
      />
      <path
        d="M32.8877 45.5679C34.8948 45.4618 36.3735 43.7665 36.2677 41.753C36.162 39.7396 34.472 38.2564 32.5705 38.3624C31.9362 38.3624 31.409 38.5745 30.8805 38.8926C29.8247 39.5289 29.1904 40.8 29.1904 42.1772C29.2961 44.0846 30.8805 45.6739 32.8877 45.5679Z"
        fill="#AD82E2"
      />
      <path
        d="M41.0153 31.1459C40.3811 31.1459 39.8539 31.358 39.3253 31.6762C39.0082 31.8882 38.7967 32.1003 38.5853 32.3124C37.951 33.0547 37.6353 33.9017 37.6353 34.9608C37.741 36.9742 39.431 38.4574 41.3325 38.3514C43.3397 38.2453 44.8183 36.55 44.7126 34.5366C44.6069 32.5231 42.9168 31.0399 41.0153 31.1459Z"
        fill="#762ECF"
      />
    </g>
    <defs>
      <clipPath id="clip0_18417_135362">
        <rect width="60" height="60" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
